import { config, library, dom } from "@fortawesome/fontawesome-svg-core"
import {
  faAnglesLeft,
  faAnglesRight,
  faCheck,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faKey,
  faLink,
  faRightFromBracket
} from "@fortawesome/free-solid-svg-icons"

config.mutateApproach = "sync"
library.add(
  faAnglesLeft,
  faAnglesRight,
  faCheck,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faKey,
  faLink,
  faRightFromBracket
)
dom.watch()
